export function AdminSettingsPage() {
  return (
    <div className="space-y-6 max-w-3xl">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Platform settings</h1>
        <p className="text-sm text-ink-500 dark:text-ink-400">
          Configuration is sourced from the Worker environment. Update values via{' '}
          <code className="font-mono text-xs">wrangler secret put</code> or your{' '}
          <code className="font-mono text-xs">wrangler.toml</code>.
        </p>
      </header>
      <section className="card p-5 space-y-3 text-sm">
        <h2 className="font-semibold">Required secrets</h2>
        <ul className="space-y-2 list-disc pl-5 text-ink-600 dark:text-ink-300">
          <li>
            <code className="font-mono">SESSION_SECRET</code> — signs short-lived password gate
            cookies.
          </li>
          <li>
            <code className="font-mono">PASSWORD_PEPPER</code> — peppers all password hashes.
          </li>
          <li>
            <code className="font-mono">VISITOR_HASH_SALT</code> — used for privacy-preserving
            visitor hashing.
          </li>
          <li>
            <code className="font-mono">ADMIN_BOOTSTRAP_EMAIL</code> /{' '}
            <code className="font-mono">ADMIN_BOOTSTRAP_PASSWORD</code> — used by the
            bootstrap script.
          </li>
        </ul>
      </section>
      <section className="card p-5 space-y-3 text-sm">
        <h2 className="font-semibold">Admin SSO</h2>
        <p className="text-ink-600 dark:text-ink-300">
          The admin backend is protected by single sign-on through your identity provider.
          Configure <code className="font-mono">ACCESS_TEAM_DOMAIN</code> and{' '}
          <code className="font-mono">ACCESS_AUD</code> in the Worker variables to enable hard
          JWT verification on every admin request.
        </p>
      </section>
    </div>
  );
}
